Ext.define('SA.SimmonsCrosstabEditController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.modelLocations = new SA.EditModelLocations(model);
        this.modelAttributes = new SA.EditModelAttributes(model);

        this.validator = SA.EditValidator.forModel(this.model);
        this.validator.addRuleType(SA.EditCrosstabAttributesRequiredRule);
        this.validator.addRuleType(SA.EditCrosstabMaximumAttributesRule);

        this.locationsPanel = SA.EditPanelBuilder.forLocations().withRadios('Select a location').build();

        this.attributesPanel = SA.EditPanelBuilder
            .forAttributes()
            .withSelectionButtons()
            .setSubheader(SA.CrosstabAttributesPanelSubheader.create())
            .setItemFactory(id => Ext.widget({xtype: 'crosstab-attributes-panel-item', dataId: id}))
            .build();

        this.view = Ext.widget({xtype: 'edit-view', panels: [this.locationsPanel.getView(), this.attributesPanel.getView()]});

        this.initEvents();
    },

    initEvents() {
        this.modelObserver = SA.EditModelObserver.create(this.model, this.refresh, this);
        this.modelObserver.observeName();
        this.modelObserver.observeLocations();
        this.modelObserver.observeAttributes();

        this.activeState.onActive(this.refresh, this);
        this.activeState.onChange(active => this.modelObserver.setEnabled(active));

        this.sidebarObserver = new SA.SidebarObserver(this.activeState);
        this.sidebarObserver.onUseAttribute(this.onSidebarUseAttribute, this);

        this.view.onDoneClick(() => SA.AppController.showProjectView(this.model));

        this.attributesPanel.onSelectAllClick(() => this.model.addProjectAttributes());
        this.attributesPanel.onClearClick(() => this.model.clearAttributes());
        this.attributesPanel.onItemChange(this.onAttributesPanelItemChange, this);
    },

    getView() {
        return this.view;
    },

    onAttributesPanelItemChange({attribute, state}) {
        var side = {top: state.column, left: state.row};

        this.model.toggleAttribute({attribute, side});
    },

    onSidebarUseAttribute(id) {
        this.view.scrollToEl(() => this.attributesPanel.getEnabledItemEl(id));
    },

    refresh() {
        this.view.setViewName(this.model.getName());
        this.view.setWarningMessage(this.validator.getFirstMessage());

        this.locationsPanel
            .setEnabledIds(this.modelLocations.getSupported())
            .setDisabledIds(this.modelLocations.getUnsupported())
            .eachItem(item => item.refreshLabel())
            .eachEnabledItem(radio => radio.setCheckedSuppressed(this.modelLocations.isSelected(radio.getDataId())));

        this.attributesPanel
            .setEnabledIds(this.modelAttributes.getSupported())
            .setDisabledIds(this.modelAttributes.getUnsupported())
            .eachEnabledItem(item => {
                var isRowAttribute = this.model.getAttributesModel().has({left: item.getDataId()}),
                    isColumnAttribute = this.model.getAttributesModel().has({top: item.getDataId()});

                item.setState({row: isRowAttribute, column: isColumnAttribute});
            });
    }
});